/**
 * Stripe keys — single module for publishable + secret.
 *
 * - `STRIPE_PUBLISHABLE_KEY`: browser / Stripe.js. Set `VITE_STRIPE_PUBLISHABLE_KEY` in `.env`.
 * - `STRIPE_SECRET_KEY`: server only (API routes, webhooks). Set `STRIPE_SECRET_KEY` in Vercel / server `.env`
 *   (Dashboard → Developers → API keys → Secret key). There is no `sk_test_` stored in this repo — add it to `.env`
 *   yourself; we intentionally do not hardcode it (unlike the publishable test key above).
 *   Do not import `STRIPE_SECRET_KEY` from client components (keep it out of the client bundle).
 */
/** Safe when this file is loaded from Node (e.g. Vercel API) where `import.meta.env` may be absent. */
export const STRIPE_PUBLISHABLE_KEY =
  import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY || "";

// SECURITY: server only. No hardcoded fallback — a missing key must fail loudly,
// never ship a live secret in a client-reachable module.
export const STRIPE_SECRET_KEY =
  (typeof process !== "undefined" ? process.env?.STRIPE_SECRET_KEY : undefined) || "";
